import { useState } from "react";
import api from "../api/axiosInstance";

// Inline styles override the .candidate-form button styles
const styles = {
  wrapper: { marginTop: 8, marginBottom: 4, width: "100%", boxSizing: "border-box" },
  error: { color: "crimson", fontSize: 12, margin: "6px 0 0" },
  heading: { fontSize: 12, color: "#555", margin: "10px 0 6px" },
  list: { display: "flex", flexDirection: "column", gap: 6, width: "100%" },
  card: {
    display: "block",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    margin: 0,
    padding: "8px 10px",
    background: "#ffffff",
    color: "#222",
    border: "1px solid #d5dbe5",
    borderRadius: 6,
    textAlign: "left",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.4,
    whiteSpace: "normal",
    textTransform: "none",
    height: "auto",
    minHeight: 0,
    cursor: "pointer",
    boxShadow: "none",
    transition: "border-color 0.15s, background 0.15s",
  },
  cardHover: { background: "#f3f6fb", borderColor: "#2c4a7a" },
  name: { display: "block", fontSize: 13, fontWeight: 600, color: "#1f3558", marginBottom: 2 },
  industry: { display: "block", fontSize: 12, color: "#555" },
  website: { display: "block", fontSize: 12, color: "#2c6ecb", overflowWrap: "anywhere", wordBreak: "break-word" },
  note: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    fontSize: 11.5,
    color: "#777",
    marginTop: 3,
  },
};

const shortUrl = (url = "") => url.replace(/^https?:\/\/(www\.)?/, "").replace(/\/$/, "");

export default function ClientAutofillButton({ clientName, industries = [], segments = [], onFill }) {
  const [loading, setLoading] = useState(false);
  const [matches, setMatches] = useState([]);
  const [error, setError] = useState("");
  const [hovered, setHovered] = useState(null);

  const apply = (m) => {
    onFill({
      clientName: m.officialName,
      website: m.website,
      industry: m.industry,
      businessSegment: m.businessSegment,
    });
    setMatches([]);
    setHovered(null);
  };

  const handleClick = async () => {
    setError("");
    setMatches([]);
    if (!clientName || clientName.trim().length < 2) {
      setError("Enter a client name first");
      return;
    }
    setLoading(true);
    try {
      // Same API address + login cookie as the rest of the app (POST /api/clients/enrich)
      const { data } = await api.post("/clients/enrich", { clientName, industries, segments });

      if (data.matches.length === 1) apply(data.matches[0]);
      else setMatches(data.matches);
    } catch (e) {
      setError(e.response?.data?.message || e.message || "Lookup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <button style={{width:"100%",marginTop:'-2px'}} type="button" onClick={handleClick} disabled={loading}>
        {loading ? "Looking up..." : "Auto-fill details"}
      </button>

      {error && <p style={styles.error}>{error}</p>}

      {matches.length > 1 && (
        <>
          <p style={styles.heading}>Did you mean:</p>
          <div style={styles.list}>
            {matches.map((m, i) => (
              <button
                key={i}
                type="button"
                onClick={() => apply(m)}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                style={{ ...styles.card, ...(hovered === i ? styles.cardHover : {}) }}
              >
                <span style={styles.name}>{m.officialName}</span>
                {m.industry && <span style={styles.industry}>{m.industry}</span>}
                {m.website && <span style={styles.website}>{shortUrl(m.website)}</span>}
                {m.note && <span style={styles.note}>{m.note}</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}